import clsx from 'clsx';
import React from 'react';
import HdModal from '../../../modal/components/modal/HdModal';
import { useObservableState } from '../../../core/hooks/useObservableState';
import useService from '../../../injector/hooks/useService';
import { ShortcutsDialogHandlerReactService } from '../../../a11y/shortcuts/service/shortcuts-dialog-handler-react.service';
import styles from './GlobalSearchDialog.module.scss';
import { GlobalSearchBody } from '../GlobalSearchBody';
import { GlobalSearchEmptyResult } from '../GlobalSearchEmptyResult';
import { GlobalSearchFooter } from '../GlobalSearchFooter/GlobalSearchFooter';
import { GlobalSearchHeader } from '../GlobalSearchHeader/GlobalSearchHeader';
import { GlobalSearchContextProvider } from '../../context/GlobalSearchContext';
import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';
import { GLOBAL_SEARCH_REGISTRY } from '../../registry/globalSearchRegistry';

const registry = { ...GLOBAL_SEARCH_REGISTRY };

export function GlobalSearchDialog() {
  const _shortcutsDialogHandlerReactService = useService(ShortcutsDialogHandlerReactService);

  const [isOpen] = useObservableState(
    _shortcutsDialogHandlerReactService.isAdvancedGlobalSearchDialogOpen()
  );

  const onClose = () => {
    _shortcutsDialogHandlerReactService.closeGlobalSearchDialog();
  };

  return (
    <HdModal
      open={isOpen}
      onClose={() => onClose()}
      placement='center'
      contentClassName={clsx(styles.globalSearchDialog)}
    >
      <GlobalSearchWithContextProvider onClose={onClose} />
    </HdModal>
  );
}

function GlobalSearchWithContextProvider({ onClose }: { onClose: Function }) {
  return (
    <GlobalSearchContextProvider
      registry={registry}
      onClose={onClose}
    >
      <GlobalSearchInner />
    </GlobalSearchContextProvider>
  );
}

function GlobalSearchInner() {
  const {
    showEntities,
    showNoResultFound,
    showBody,
    bodyRef,
  } = useGlobalSearchContext();

  return (
    <div ref={bodyRef} data-id={"global-search-dialog"}>
      <GlobalSearchHeader />

      {showBody ? (
        <div data-id='global-search-dialog-body' className={clsx(styles.globalSearchDialogBody)}>
          {showEntities ? (
            <GlobalSearchBody />
          ) : null}

          {showNoResultFound ? (
            <GlobalSearchEmptyResult />
          ) : null}
        </div>
      ) : null}

      <GlobalSearchFooter />
    </div>
  );
}
